import drawing from '../map/draw';

class MultiShapeDrawer {
    constructor() {
        this.isDrawing = false;
    }

    init() {
        const $startButton = $('#tool-multidraw-start');
        const $stopButton = $('#tool-multidraw-stop');

        $startButton.parent().show();
        $stopButton.parent().hide();

        $startButton.on('click', () => {
            this.isDrawing = true;
            $startButton.hide();
            $stopButton.show();
            this._enableContinuousDrawing();
        });

        $stopButton.on('click', () => {
            this.isDrawing = false;
            drawing.hide();
            $startButton.show();
            $stopButton.hide();
        });
    }

    _enableContinuousDrawing() {
        if (!this.isDrawing) return;

        drawing.show({
            polygon: true,
            rectangle: true,
            circle: true
        }, (event) => {
            this._enableContinuousDrawing();
        });

        // Oculta controles se necessário
        $(drawing.getControls().getContainer()).hide();
    }
}

export default MultiShapeDrawer;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/MultiShapeDrawer.js